import { STAGE } from '@/constants';

const AWS_REGION = 'eu-central-1';

const CognitoPoolId = {
  dev: 'eu-central-1_7TEjEhkz5',
  ppr: 'eu-central-1_03o78dHah',
  prod: 'eu-central-1_QBAIDkX7D'
};

const CognitoClientId = {
  dev: 'nlj5trc4lmiuk0r9ssf7jve1e',
  ppr: '27k88u9iq2i24kb4ubl6isv961',
  prod: '6asbcj697hml02ad533q9ol2bd'
};

const CognitoIdentityPoolId = {
  dev: 'eu-central-1:295c1834-2775-4209-9a75-73b3a138b060',
  ppr: 'eu-central-1:d453facf-d5bd-4387-8c67-fa5a16440fef',
  prod: 'eu-central-1:f8b9a091-c799-49f1-8ebb-cc08c62dd76f'
};

const graphQlEnpoints = {
  dev:
    'https://meteocast-dev.radarmeteo.com/graphql',
  ppr:
    'https://meteocast-ppr.radarmeteo.com/graphql',
  prod:
    'https://meteocast.radarmeteo.com/graphql'
};

const getValueByEnvironment = (valueSet, env) => valueSet[env];

export const configuration = {
  Auth: {
    region: AWS_REGION,
    userPoolId: getValueByEnvironment(CognitoPoolId, STAGE),
    userPoolWebClientId: getValueByEnvironment(CognitoClientId, STAGE)
  },
  aws_project_region: AWS_REGION,
  aws_appsync_graphqlEndpoint: getValueByEnvironment(graphQlEnpoints, STAGE),
  aws_appsync_region: AWS_REGION,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_identity_pool_id: getValueByEnvironment(
    CognitoIdentityPoolId,
    STAGE
  )
};
